import axios from 'axios'

import store from '@/stores'

import Servico from './Servico'

const URL = process.env.VUE_APP_API_URL

class EstadoServico extends Servico {
  constructor() {
    super('estados')
  }

  recuperarUfs() {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarCidades(sigla) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/${sigla}/cidades`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }
}

export default EstadoServico
